<template>
    <div class="container-fluid">
        <div class="d-flex p-2 justify-content-center align-items-center">
            <div>

                <div role="alert" aria-live="assertive" aria-atomic="true" class="toast" style="position: absolute;top: 20px;width: 300px;background-color: rgba(255, 0, 0, 0.6);" data-autohide="true">
                    <div class="toast-body text-center" style="color: white;">
                        {{$t('Calendar not found !')}}
                    </div>
                </div>

                <h1><font-awesome-icon :icon="['fas', 'blender-phone']" /> <span style="font-size: 40px !important;">QuickLy</span></h1>
                <p style="font-size: 11px;text-align: center;color: #7b7b7b;">by <a href="https://greenbull.group/" target="_blank" style="color:#7b7b7b;font-style: italic;">GreenBull Group</a></p>
            </div>
        </div>
    </div>

</template>

<script>
    import {activateToast} from '../assets/js/callToast';
    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {},
        components: {},
        created: function () {

        },
        mounted: function () {
            activateToast('toast');
        },
        methods: {},
        name: 'NotFoundPage'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>